import { Box, Button, ModalBase, Stack, Typography } from '@chronosphereio/chrono-ui';
import { useFeatureFlags } from '@chronosphereio/core';
import { SavedView } from '@/core';

interface DeleteVariableDialogProps {
  isOpen: boolean;
  variableName: string;
  affectedSavedViews: SavedView[];
  onConfirmRemove: () => void; // Remove from saved views and delete
  onConfirmKeep: () => void; // Keep stale and delete
  onCancel: () => void;
}

export function DeleteVariableDialog({
  isOpen,
  variableName,
  affectedSavedViews,
  onConfirmRemove,
  onConfirmKeep,
  onCancel,
}: DeleteVariableDialogProps) {
  const { panwRebrandStubYear } = useFeatureFlags();
  const viewCount = affectedSavedViews.length;
  const viewNames = affectedSavedViews.map((view) => view.name).join(', ');

  const handleRemove = () => {
    onConfirmRemove();
    onCancel();
  };

  const handleKeep = () => {
    onConfirmKeep();
    onCancel();
  };

  return (
    <ModalBase
      open={isOpen}
      title={`Delete variable "${variableName}"`}
      onClose={onCancel}
      size="small"
      Footer={
        <Box p={1} justifyContent="flex-end" width="100%" display="flex" flexDirection="row" alignItems="center">
          <Stack direction="row" spacing={1}>
            {panwRebrandStubYear && (
              <Button variant="secondary" onClick={onCancel}>
                Cancel
              </Button>
            )}
            <Button variant="primary" onClick={handleRemove}>
              Yes, remove from saved views
            </Button>
            <Button variant="secondary" onClick={handleKeep}>
              No, keep values
            </Button>
            {!panwRebrandStubYear && (
              <Button variant="secondary" onClick={onCancel}>
                Cancel
              </Button>
            )}
          </Stack>
        </Box>
      }
    >
      <Box px={2} pb={1}>
        <Stack spacing={2}>
          <Typography>
            This variable is used in {viewCount} saved {viewCount === 1 ? 'view' : 'views'}. Do you want to remove the
            values for this variable from {viewCount === 1 ? 'this saved view' : 'these saved views'}?
          </Typography>

          {viewCount > 0 && (
            <div>
              <Typography variant="body2" color="text.secondary" fontWeight="bold" mb={1}>
                Affected saved {viewCount === 1 ? 'view' : 'views'}:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {viewNames}
              </Typography>
            </div>
          )}
        </Stack>
      </Box>
    </ModalBase>
  );
}
